











import { Vue, Component, Watch } from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {CLICK_AND_COLLECT_ROUTES} from "@/constants/routes";
import {EClickCollectType} from "@/constants/orders";
import OrderWrapper from "@/views/components/Orders/OrderWrapper.vue";

const parseStep = (n: number | string): number => typeof n === 'string' ? parseInt(n, 10) : n;
const shipmentModule = namespace("shipment");

@Component({
  name: 'ClickAndCollect',
  components: {
    OrderWrapper,
  },
})
export default class ClickAndCollect extends Vue {
  @shipmentModule.Getter('getCCType')
  private type!: EClickCollectType;

  private pageTitle: string = "";
  private step: number = 1;
  private numSteps: number = 4;

  @Watch("$route")
  private updateStep() {
    switch (this.$route.name) {
      case CLICK_AND_COLLECT_ROUTES.START:
        this.step = 1;
        break;

      case CLICK_AND_COLLECT_ROUTES.FORM:
        this.step = 2;
        break;

      case CLICK_AND_COLLECT_ROUTES.SUMMARY:
        this.step = 3;
        break;

      case CLICK_AND_COLLECT_ROUTES.FINISH:
        this.step = 4;
        this.numSteps = 0;
    }
  }

  private created() {
    this.pageTitle = this.$t('clickAndCollect.title') as string;
    this.updateStep();
  }

  private goToStepWithData(n: number | string, params?: any) {
    this.step =  parseStep(n);
  }

  private goToStep(n: number | string) {
    this.goToStepWithData(n);
    if (this.step === 1) {
      this.$router.push({name: CLICK_AND_COLLECT_ROUTES.START});
    }

    if (this.step === 2) {
      this.$router.push({name: CLICK_AND_COLLECT_ROUTES.FORM});
    }
  }
}
